import { render, staticRenderFns } from "./LabelsFilters.vue?vue&type=template&id=4a03b1d1&"
import script from "./LabelsFilters.vue?vue&type=script&lang=js&"
export * from "./LabelsFilters.vue?vue&type=script&lang=js&"
import style0 from "./LabelsFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports